module.exports = __webpack_public_path__ + "img/5_59.437d7aa8.png";